import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import AuthService from "../services/auth.service";
import { useAppContext } from "../AppContext";

const LoginCallbackPage = () => {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");

  const [searchParams] = useSearchParams();
  let navigate = useNavigate();

  const { currentUser } = useAppContext();

  // if logged in, log out first to set password
  if (currentUser) {
    AuthService.logout();
    navigate(0);
  }

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');
    const errorKey = searchParams.get('errorKey');
    const redirected = searchParams.get('redirected');
    const target = searchParams.get('target');

    if (errorKey) {
      // Use translation key from server
      setMessage("Login error: " + t(errorKey));
    } else if (error) {
      // Fallback for old error format
      setMessage("Login error: " + error);
    } else if (redirected && target) {  
      localStorage.setItem('preferredEnvironment', target);
      window.location.href = `https://${target}.risqui.nl/?redirected=true&autoLoginToken=${token}`;
    } else if (token) {
      // On success, store the token (in local storage, context, etc.)
      AuthService.setLocalStorage(token);
      
      // Remove token from URL to prevent re-triggering
      window.history.replaceState({}, document.title, "/");
      window.location.reload();
    }
    else {
      setMessage("Invalid link.");
    }
  }, [searchParams]);


  return (
    <div id="login-container">
      <div className="container">
        <div className="col-md-12">
          <div id="login-content">

            <div className="card card-container">
              <div className="profile-img-card" />
              <h1>Logging in</h1>
              <h3>Please wait..</h3>

              <hr />

              {message && (
                <>
                  <div className="form-group">
                    <div className={"alert alert-" + (message.includes("success") ? "success" : "danger")} role="alert" style={{ whiteSpace: 'pre-line' }}>
                      {message}
                    </div>
                  </div>

                  <br/>

                  <a href="#" onClick={() => window.location.href='/'} style={{textDecoration: 'underline'}}>Click here to try again</a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginCallbackPage;
